import { createQueryKeys } from '@lukemorales/query-key-factory';

// Paid services (ID-213). Slices add their own keys here.
export const serviceOrders = createQueryKeys('serviceOrders', {
  adminOfferings: null,
  adminOffering: (id: string) => [id],
  adminOfferingHistory: (id: string) => [id],
  adminSettings: null,
  adminStaffAccess: null,
});
